import React, { useState, useEffect } from 'react';
import './Register.css';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const Associations = () => {
    const [associationVisible, setAssociationVisible] = useState(false);

    const handleAssociationChange = (e) => {
        setAssociationVisible(e.target.value === 'Yes');
    };

 

    return (
        <div className="ugf-bg ufg-main-container">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2 p-sm-0">
                        <div className="ugf-form">
                            <form name="contact" method="POST"  >
                                <input type="hidden" name="contact" value="contact" />
                                <div hidden>
        <input name="bot-field" />
      </div>
                                <div className="input-block">
                                    <h4>Association/Club Registration Form</h4>
                             <div className="row">
                                        <div className="col-md-6 p-sm-0" style={{ marginLeft: '-5px' }}>
                                            <div className="form-group">
                                                <label htmlFor="Association_Name">Name of Association/Club</label>
                                                <input type="text" name="Association_Name" className="form-control" id="Association_Name" placeholder="Enter your Association name" required />
                                               
                                            </div>
                                        </div>
                                        <div className="col-md-6 p-sm-0">
                                            <div className="form-group">
                                                <label htmlFor="Registration_No">Registration Number (if any)</label>
                                                <input type="number" name="Registration_No" className="form-control" id="Registration_No" placeholder="e.g. 111123234"  />
                                            </div>
                                        </div>
                            </div>
                            <div className='row'>
                                        <div className="col-md-6 p-sm-0">
                                            <div className="form-group">
                                                <label htmlFor="Adress">Address</label>
                                                <input type="text" name="Adress" className="form-control" id="Adress" placeholder="e.g.NO 1 Commisioner Road" required />
                                            </div>
                                        </div>
                                        <div className="col-md-6 p-sm-0">
                                            <div className="form-group">
                                                <label htmlFor="DOB">Date of Establishment</label>
                                            
                                                <div className="birth-date">
                                                    <div className="select-input birth-date-input">
                                                        <span></span>
                                                        <select id="inputDate" name="day" className="form-control" required>
                                                            <option value="">Date</option>
                                                            {[...Array(31)].map((_, i) => (
                                                                <option key={i + 1} value={i + 1}>
                                                                    {String(i + 1).padStart(2, '0')}
                                                             </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="select-input birth-date-input">
                                                        <span></span>
                                                        <select id="inputMonth" name="month" className="form-control" required>
                                                                <option value="">Month</option>
                                                                {[...Array(12)].map((_, i) => (
                                                                                                                                <option key={i + 1} value={i + 1}>
                                                                        {String(i + 1).padStart(2, '0')}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                    </div>
                                                    <div className="select-input birth-date-input">
                                                        <span></span>
                                                        <select id="inputYear" name="year" className="form-control" required>
                                                                <option value="">Year</option>
                                                                {Array.from({ length: 50 }, (_, i) => 1970 + i).map(year => (
                                                                    <option key={year} value={year}>
                                                                        {year}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                             </div>
                             <div className='row'>
                                       <div className="col-md-6 p-sm-0">
                                       <div className="form-group">
                                                <label htmlFor="Email">Email Adress</label>
                                                <input type="mail" name="Email" className="form-control" id="Email" placeholder="e.g. myassociation@gmail.com"  />
                                            </div>
                                        </div>
                                        <div className="col-md-6 p-sm-0">
                                            <div className="form-group">
                                                <label htmlFor="Website">Website (if any)</label>
                                                <input type="url" className="form-control" name="Website" id="Website" placeholder="e.g. www.myassociation.ng"  />
                                            </div>
                                        </div>

                             </div>
                             <div className='row'>

                                   <div className="col-md-6 p-sm-0">
                                   <div className="form-group">
                                                <label htmlFor="Contact_Person">Contact Person Full Name</label>
                                                <input type="text" className="form-control" name="Contact_Person" id="Contact_Person" placeholder="e.g.yusuf" required />
                                            </div>
                                        </div>
                                        <div className="col-md-6 p-sm-0">
                                        <div className="form-group">
                                                <label htmlFor="Email">Email</label>
                                                <input type="mail" className="form-control" name="Email" id="Email" placeholder="e.g.yusuf" required />
                                            </div>
                                        </div>

                             </div>
                             <div className='row'>
                                   <div className="col-md-6 p-sm-0">
                                            <div className="form-group">
                                                <label htmlFor="PhoneNumber">Phone number</label>
                                                <input type="tel" className="form-control" name="PhoneNumber" id="PhoneNumber" placeholder="e.g. 09131313131" required />
                                            </div>
                                        </div>
                                        <div className="col-md-6 p-sm-0">
                                    <div className="form-group">
                                        <label htmlFor="Email" className="questionsLabel">Email Adress</label>
                                        <input type="mail" name="Email" className="form-control" id="Email" placeholder="eg youthsportal@gmail.com" />
                                    </div>
                                    </div>
                                        

                             </div>
                
                         
                                
                               
                                    
                             
                      
                                        <div className='row'>
                                  <div className="col-md-6 p-sm-0">
                                  <div className="form-group">
                                        <label htmlFor="No_Of_Members">Total Number of Members</label>
                                        <input type="number" name="No_Of_Members" className="form-control" id="No_Of_Members" placeholder="100" required />
                                    </div>
                                    </div>
                                    <div className="col-md-6 p-sm-0">
                                    <div className="form-group">
                                        <label htmlFor="Description_Of_Activities">Description of Activities</label>
                                        <input type="text" name="Description_Of_Activities" className="form-control" id="Description_Of_Activities" placeholder="Describe" />
                                    </div>
                                    </div>

                             </div>
                                   
                                    
                                </div>
                                <div className="input-block">
                                    <div className="form-group">
                                        <div className="custom-checkbox">
                                            <input type="checkbox" name="checkBox" className="custom-control-input" id="customControlValidation1" required />
                                            <label className="custom-control-label" htmlFor="customControlValidation1">
                                               
                                                We  hereby declare that the information we provided is true and accurate.
                                           
                                            </label>
                                        </div>
                                    </div>
                                   
                                </div>
                                
                                
                                <button className="btn" type="submit" style={{backgroundColor:"green",}}>Submit Documents</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Associations;
